import React, { useMemo } from "react";
import { ResponsiveBox } from "@usap/uicomponents";

export default function Container({
  hideBorder,
  borderColor = "#333333",
  children,
  isPdpRp1Enabled,
  ...rest
}) {
  const styleManager = useMemo(() => {
    return {
      padding: { horizontal: "6px", vertical: "8px" },
      border: { size: hideBorder ? "0px" :"1px", color: borderColor },
      borderNew: { size: hideBorder ? "0px" :"2px", color: borderColor },
      round: hideBorder ? "0px" : "4px",
      marginVerticle: hideBorder ? {} : { vertical: "medium" },
      marginBottom: hideBorder ? {} : { bottom: "medium" }
    };
  }, [borderColor, hideBorder]);

  return (
    <ResponsiveBox
      border={ isPdpRp1Enabled ? styleManager.borderNew : styleManager.border}
      round={styleManager.round}
      pad={styleManager.padding}
      fxMargin={{
        large: styleManager.marginVerticle,
        other: styleManager.marginBottom
      }}
      {...rest}
    >
      {children}
    </ResponsiveBox>
  );
}
